<template>
  <div class="page sizeA4">
    <div class="m-4">
      <!-- imagens do topo -->
      <div class="row">
        <div class="d-flex justify-content-between mb-2">
          <div class="col-md-6">
            <img
              style="width: 60%"
              src="@/assets/images/extrato/unicampoLogo.jpg"
            />
          </div>
          <div class="col-md-6">
            <div class="barraVerde"></div>
          </div>
        </div>
      </div>
      <!-- informações do cooperado -->
      <div class="row">
        <div class="col-md-12 mb-3">
          <h1 class="text-dark fw-bolder">
            Olá, {{ rdvInfo.rdv.nm_cooperado }}
          </h1>
          <h1 class="text-dark fw-bolder">
            Aqui está o seu
            <span class="text-success">extrato do acerto</span> de
          </h1>
          <h1 class="text-dark fw-bolder">
            {{ rdvInfo.rdv.ds_dt_referencia }}
            {{ rdvInfo.rdv.dt_referencia.substr(0, 4) }}
          </h1>
        </div>
      </div>
      <!-- informações do RDV -->
      <div class="row">
        <div class="d-flex flex-column col-md-2">
          <span class="text-dark fw-bolder me-2">COOPERADO(A)</span>
          <span class="text-dark fw-bolder me-2">CÓDIGO RDV</span>
          <span class="text-dark fw-bolder me-2">PERÍODO</span>
          <span class="text-dark fw-bolder me-2">STATUS DO RDV</span>
          <span class="text-dark fw-bolder me-2">PROJETO</span>
        </div>
        <div class="d-flex flex-column col-md-10">
          <span class="text-dark fw-bolder me-2">
            <strong class="fw-lighter"
              >{{ rdvInfo.rdv.nm_cooperado }} [{{ rdvInfo.rdv.cd_pessoa }}]
            </strong>
          </span>
          <span class="text-dark fw-bolder me-2">
            <strong class="fw-lighter">{{ rdvInfo.rdv.cd_rdv }}</strong>
          </span>
          <span class="text-dark fw-bolder me-2">
            <strong class="fw-lighter">
              {{
                this.$tools.converteData(rdvInfo.rdv.dt_inicio.substr(0, 10))
              }}
              a {{ this.$tools.converteData(rdvInfo.rdv.dt_fim.substr(0, 10)) }}
            </strong>
          </span>
          <span class="text-dark fw-bolder me-2">
            <strong class="fw-lighter">{{
              rdvInfo.rdv.ds_st_rdv.toUpperCase()
            }}</strong>
          </span>
          <span class="text-dark fw-bolder me-2">
            <strong class="fw-lighter"
              >{{ rdvInfo.rdv.nm_projeto }} [{{
                rdvInfo.rdv.cd_projeto
              }}]</strong
            >
          </span>
        </div>
      </div>
      <!-- resumo de movimentações rdv -->
      <div class="row">
        <div class="d-flex justify-content-center flex-column text-center my-3">
          <h2 class="text-dark fw-bolder mb-3">
            <i class="mdi mdi-clipboard-text-multiple align-middle me-2"></i
            >Resumo das Movimentações
          </h2>
          <h5 class="text-dark fw-bolder">Você movimentou este mês</h5>
          <span class="text-success fw-bolder font-size-24">{{
            $tools.converteReal(rdvInfo.rdv.vl_despesa)
          }}</span>
          <hr
            class="my-3 m-auto"
            style="
              width: 28em;
              height: 0.5em;
              color: #000;
              opacity: 1 !important;
            "
          />
          <h5 class="text-dark fw-bolder">
            Saldo final
            <span
              class="fw-bolder font-size-24"
              :class="{
                'text-primary ': parseInt(rdvInfo.rdv.vl_previsao_acerto) > 0,
                'text-danger': parseInt(rdvInfo.rdv.vl_previsao_acerto) < 0,
              }"
            >
              {{ $tools.converteReal(rdvInfo.rdv.vl_previsao_acerto) }}
            </span>
          </h5>
          <span class="fw-bolder me-2">
            Data de Liquidação foi
            <strong>
              {{
                this.$tools.converteData(rdvInfo.rdv.dt_acerto.substr(0, 10))
              }}</strong
            >
          </span>
        </div>
      </div>
      <!-- gastos por carteira e por norma -->
      <div class="row my-5">
        <div class="d-flex" ref="minhaDiv">
          <div class="col-md-6">
            <div>
              <h4 class="text-dark fw-bolder text-center mb-4">
                Gastos por Carteira
              </h4>
              <div
                class="d-flex mb-3 col-md-12"
                v-for="(carteira, index) in despesaCarteira"
                :key="index"
              >
                <div class="col-md-12">
                  <span class="text-dark fw-bolder">{{ carteira.nome }}</span>
                  <b-progress>
                    <b-progress-bar
                      :value="montaPorcentagem(index)"
                      :style="'background-color:' + atribuiCor(carteira.nome)"
                    ></b-progress-bar>
                  </b-progress>
                  <div></div>
                  <p class="text-dark fw-bolder mt-2">
                    {{ $tools.converteReal(carteira.somaAprovado) }} de
                    {{ $tools.converteReal(rdvInfo.rdv.vl_despesa) }} ({{
                      montaPorcentagem(index).toFixed(2)
                    }}% )
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="vertical" ref="vertical"></div>
          <div class="col-md-6 mx-1">
            <h4 class="text-dark fw-bolder text-center mb-2">
              Gastos por Norma
            </h4>
            <div
              class="d-flex mb-2"
              v-for="(norma, index) in despesasPorNorma.norma"
              :key="index"
            >
              <div v-if="norma" class="col-md-12">
                <span class="text-dark fw-bolder">{{ norma.nome }}</span>
                <b-progress
                  :value="
                    (norma.valor / parseFloat(despesasPorNorma.soma)) * 100
                  "
                  :variant="
                    corDaPorcentagem(
                      (norma.valor / parseFloat(despesasPorNorma.soma)) * 100
                    )
                  "
                ></b-progress>
                <p class="text-dark fw-bolder mt-1">
                  {{ $tools.converteReal(norma.valor) }}
                  ({{
                    ((norma.valor / parseFloat(despesasPorNorma.soma)) * 100)
                      .toFixed(2)
                      .replace(".", ",")
                  }}
                  %)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- RODAPÉ -->
      <div class="row quebraPagina">
        <div class="d-flex justify-content-between mt-5">
          <div class="col-md-6 align-self-end">
            <div class="barraVerde"></div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="d-flex justify-content-between mb-2">
          <div class="col-md-6">
            <img
              style="width: 60%"
              src="@/assets/images/extrato/unicampoLogo.jpg"
            />
          </div>
          <div class="col-md-6">
            <div class="barraVerde"></div>
          </div>
        </div>
      </div>
      <!-- movimentações por carteira -->
      <div class="row">
        <h2 class="text-dark fw-bolder mb-4">Movimentações por Carteira</h2>

        <div
          class="my-3"
          v-for="(carteira, index) in despesaCarteira"
          :key="index"
        >
          <div class="d-flex">
            <div
              class="retangulo mr-2"
              :style="'background-color:' + atribuiCor(carteira.nome)"
            ></div>
            <span class="text-dark fw-bolder">{{ carteira.nome }}</span>
          </div>
          <div class="mt-2">
            <h1 class="fw-bolder" :style="'color:' + atribuiCor(carteira.nome)">
              {{ $tools.converteReal(carteira.valorTotalTransacao) }}
            </h1>
          </div>
          <div class="d-flex justify-content-evenly align-items-center">
            <div
              class="col-auto text-center"
              v-if="carteira.nome == 'Adiantamento'"
            >
              <span class="text-dark fw-bolder">Valor fornecido</span>
              <h2 class="text-dark fw-bolder p-2">
                {{ $tools.converteReal(carteira.vl_adiantamento) }}
              </h2>
            </div>
            <i class="dripicons-dot" v-if="carteira.nome == 'Adiantamento'"></i>
            <div class="col-auto text-center">
              <span class="text-dark fw-bolder"
                >Total Valor Original das Despesas Lançadas</span
              >
              <h2 class="text-dark fw-bolder p-2">
                {{ $tools.converteReal(carteira.valorLancado) }}
              </h2>
            </div>
            <i class="dripicons-minus"></i>
            <div class="col-auto text-center">
              <span class="text-dark fw-bolder">Total Valor Aprovado</span>
              <h2 class="text-success fw-bolder p-2">
                {{ $tools.converteReal(carteira.somaAprovado) }}
              </h2>
            </div>
            <i class="mdi mdi-equal"></i>
            <div class="col-auto text-center">
              <span class="text-dark fw-bolder">Saldo (Não Aprovado)</span>
              <h2
                class="fw-bolder p-2"
                :class="{
                  'text-danger':
                    carteira.valorLancado - carteira.somaAprovado < 0,
                  'text-danger':
                    carteira.valorLancado - carteira.somaAprovado > 0,
                  'text-dark':
                    carteira.valorLancado - carteira.somaAprovado === 0,
                }"
              >
                {{
                  $tools.converteReal(
                    carteira.valorLancado - carteira.somaAprovado
                  )
                }}
              </h2>
            </div>
          </div>
          <div class="mt-5">
            <span class="fw-bolder">MOVIMENTAÇÕES E DESPESAS</span>
            <b-table
              responsive="sm fw-bold"
              :items="carteira.transacoes"
              :fields="camposMovDespesa"
              per-page="1000"
            >
              <template v-slot:cell(ds_norma)="data">
                <div
                  v-if="
                    data.item.ds_tipo_carteira == 'A' ||
                    data.item.ds_tipo_carteira == 'P'
                  "
                >
                  <span> {{ data.item.ds_norma }} </span>
                </div>
                <div v-else-if="data.item.ds_tipo_carteira == 'M'">
                  <span> {{ data.item.estabelecimento_mastercard }} </span>
                </div>
                <div v-else-if="data.item.ds_tipo_carteira == 'V'">
                  <span> {{ data.item.estabelecimento_visa }} </span>
                  <!-- <span v-if="data.item.tipo_visa_transacao == 6011"
                        class="badge badge-pill font-size-12 badge-soft-warning">
                      Saque
                  </span> -->
                </div>
                <div v-else-if="data.item.ds_tipo_carteira == 'U'">
                  <span> {{ data.item.estabelecimento_frota }} </span>
                </div>
                {{ detalhes(data) }}
              </template>
              <template v-slot:cell(vl_lancamento)="data">
                <div
                  v-if="
                    data.item.ds_tipo_carteira == 'M' ||
                    data.item.ds_tipo_carteira == 'V'
                  "
                >
                  {{
                    $tools.converteReal(
                      data.item.despesas.reduce(
                        (a, b) => a + parseFloat(b.vl_lancamento),
                        0
                      ),
                      true
                    )
                  }}
                </div>
                <div
                  else
                  v-if="
                    data.item.ds_tipo_carteira != 'M' &&
                    data.item.ds_tipo_carteira != 'V'
                  "
                >
                  {{ $tools.converteReal(data.item.vl_lancamento) }}
                </div>
              </template>
              <template v-slot:cell(ds_st_lancamento)="data">
                <span
                  v-if="
                    data.item.ds_tipo_carteira == 'P' ||
                    data.item.ds_tipo_carteira == 'A' ||
                    data.item.ds_tipo_carteira == 'U'
                  "
                  class="badge badge-pill font-size-12"
                  :class="$tools.corBadge(data.item.st_lancamento)"
                >
                  {{ data.value }}
                </span>
                <span
                  v-else-if="
                    data.item.ds_tipo_carteira == 'M' ||
                    data.item.ds_tipo_carteira == 'V'
                  "
                >
                  {{
                    $tools.converteReal(
                      parseFloat(data.item.vl_original) -
                        data.item.despesas.reduce(
                          (a, b) => a + parseFloat(b.vl_lancamento),
                          0
                        )
                    )
                  }}
                </span>
              </template>
              <template v-slot:cell(pendencia)="data">
                <span
                  v-for="(pendencia, index) in verificarPendencias(data.item)"
                  :key="index"
                  :class="'badge badge-pill font-size-12 m-2 ' + pendencia.cor"
                >
                  {{ pendencia.nome }}
                </span>
              </template>
              <template v-slot:row-details="data">
                <!-- <b-card> -->
                <b-table
                  class="datatables"
                  responsive="sm"
                  :fields="camposDespesasTransacoes"
                  :items="data.item.despesas"
                  style="background-color: aliceblue"
                >
                  <template #head(ds_norma)="">
                    <i class="mdi mdi-subdirectory-arrow-right" /> Norma
                  </template>
                  <template v-slot:cell(ds_st_lancamento)="row">
                    <span
                      class="badge badge-pill font-size-12"
                      :class="{
                        'badge-soft-primary': row.value === 'Liberado',
                        'badge-soft-danger': row.value === 'Não Vinculado',
                        'badge-soft-danger': row.value === 'Rejeitado',
                        'badge-soft-secondary': row.value === 'Pré-rejeitado',
                        'badge-soft-warning': row.value === 'Pendente',
                        'badge-soft-info': row.value === 'Pré-aprovado',
                        'badge-soft-success': row.value === 'Aprovado',
                      }"
                    >
                      {{ row.value }}
                    </span>
                  </template>
                </b-table>
                <!-- </b-card> -->
              </template>
              <template #foot()="">
                <h6></h6>
              </template>
              <template #foot(ds_norma)="">
                <div class="text-end">
                  <span class="text-dark fw-bold">TOTAIS </span>
                </div>
              </template>
              <template #foot(vl_original)="">
                <span class="text-dark">
                  {{ $tools.converteReal(carteira.valorLancado) }}
                </span>
              </template>
              <template #foot(vl_lancamento)="">
                <span class="text-success">
                  {{ $tools.converteReal(carteira.somaAprovado) }}
                </span>
              </template>
              <template #foot(saldo)="">
                <span
                  :class="{
                    'text-danger':
                      carteira.valorLancado - carteira.somaAprovado < 0,
                    'text-primary':
                      carteira.valorLancado - carteira.somaAprovado > 0,
                  }"
                >
                  {{
                    $tools.converteReal(
                      carteira.valorLancado - carteira.somaAprovado
                    )
                  }}
                </span>
              </template>
            </b-table>
            <div class="d-flex justify-content-evenly align-items-center mb-4">
              <div class="col-4 text-center">
                <span class="text-dark fw-bolder">Totais</span>
              </div>
              <div class="col-2 text-start">
                <span class="text-dark fw-bolder mx-5 font-size-14">
                  {{ $tools.converteReal(carteira.valorLancado) }}</span
                >
              </div>
              <div class="col-6 text-start">
                <span class="text-dark fw-bolder mx-5 font-size-14">{{
                  $tools.converteReal(carteira.somaAprovado)
                }}</span>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <span class="text-dark fw-bold">
              Quantidade total de despesas lançadas:
            </span>
            <span
              class="badge badge-pill rounded-3 font-size-12 badge-soft-secondary mx-3"
            >
              {{ carteira.totalTransacao }}
            </span>
          </div>
          <div class="d-flex">
            <span class="text-dark"> Aprovada(s): </span>
            <span
              class="badge badge-pill rounded-3 font-size-12 badge-soft-success mx-3"
            >
              {{ carteira.totalAprovado }}
            </span>
          </div>
          <div class="d-flex">
            <span class="text-dark"> Rejeitada(s): </span>
            <span
              class="badge badge-pill rounded-3 font-size-12 badge-soft-danger mx-3"
            >
              {{ carteira.totalRejeitado }}
            </span>
          </div>
          <hr />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  layout: "empty",
  data() {
    return {
      rdvInfo: [],
      carteirasInfo: [],
      despesasGeral: [],
      despesasPorNorma: [],
      despesaCarteira: {},
      tabelaMovSaque: [],
      camposMovDespesa: [
        {
          key: "dt_lancamento",
          label: "Data",
          class: "fw-bolder",
          formatter: (value) => {
            return this.$tools.converteData(value);
          },
        },
        {
          key: "ds_norma",
          label: "Transação/Despesa",
          class: "fw-bolder",
        },
        {
          key: "vl_original",
          label: "Valor Original",
          class: "alinharCelulaDireita fw-bolder",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
        {
          key: "vl_lancamento",
          label: "Valor Despesa(s)",
          class: "alinharCelulaDireita fw-bolder",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
        {
          key: "ds_st_lancamento",
          label: "Status/Saldo",
          class: "alinharCelulaDireita fw-bolder",
        },
        {
          key: "pendencia",
          label: "Pendencias",
          sortable: true,
        },
      ],
      camposDespesasTransacoes: [
        {
          key: "ds_norma",
          label: "Norma",
          thStyle: { "text-align-last": "start" },
        },
        {
          key: "dt_lancamento",
          label: "Data",
          class: "alinharCelula",
          formatter: (value) => {
            return this.$tools.converteData(value);
          },
        },
        {
          key: "vl_lancamento",
          label: "Valor",
          class: "alinharCelulaDireita",
          formatter: (value) => {
            return this.$tools.converteReal(value);
          },
        },
        {
          key: "ds_st_lancamento",
          label: "Situação",
          class: "alinharCelula",
        },

        {
          key: "cidade_uf_movimento",
          label: "Cidade",
        },
      ],
      tabelaMovDespesa: [],
    };
  },
  created() {
    this.$store.commit("SET_MOSTRA_MENU", false);
    if (this.$store.state.rdvCooperado) {
      this.rdvInfo = this.$store.state.rdvCooperado;
      this.buscaInformacoes(this.rdvInfo.rdv.cd_rdv);
    } else {
      this.$router.push("/cooperado/rdv");
    }
    window.scrollTo(0, 0);
  },
  mounted() {
    setTimeout(() => {
      this.tamanhoDiv();
    }, 3000);
  },
  methods: {
    async buscaInformacoes(cdRdv) {
      //CHAMO AS DESPESAS GERAIS E DEPOIS ORGANIZO POR NORMA
      this.despesas = await this.$tools.filtroCooperado.buscarDespesas(cdRdv);
      this.carteirasInfo = await this.$tools.filtroCooperado.buscarCarteiras(
        cdRdv
      );
      this.despesasPorNorma = this.$tools.criarGraficoDespesas(cdRdv);
      this.montaDadosCarteira(this.despesas);
    },
    atualizarAlturaLinha() {
      const divAltura = this.$refs.minhaDiv.offsetHeight + "px";
      this.$el.style.setProperty("--linha-altura", divAltura);
    },
    montaDadosCarteira(paramDespesa) {
      //soma o valor da despesas gerais
      paramDespesa = paramDespesa.filter(
        (el) => el.nivel == 1 || el.nivel == 0
      );
      paramDespesa.forEach((despesa) => {
        this.dividirDespesa(despesa.ds_carteira, despesa);
      });
    },
    dividirDespesa(carteira, transacao) {
      if (!this.despesaCarteira[carteira]) {
        this.despesaCarteira[carteira] = {};
        this.despesaCarteira[carteira].transacoes = [];
        this.despesaCarteira[carteira].nome = carteira;
        this.despesaCarteira[carteira].somaAprovado = 0;
        this.despesaCarteira[carteira].totalAprovado = 0;
        this.despesaCarteira[carteira].totalRejeitado = 0;
        this.despesaCarteira[carteira].valorLancado = 0;
        this.despesaCarteira[carteira].valorTotalTransacao = 0;
        this.despesaCarteira[carteira].totalTransacao = 0;
      }
      transacao.despesas = [];
      let despesaAux = [];
      this.despesaCarteira[carteira].valorTotalTransacao += parseFloat(
        transacao.vl_original
      );
      this.despesaCarteira[carteira].totalTransacao += 1;
      if (carteira == "Mastercard") {
        despesaAux = this.despesas.filter(
          (value) =>
            value.nivel == 2 &&
            parseInt(value.id_mastercard_transacao) ==
              parseInt(transacao.id_mastercard_transacao)
        );
        despesaAux.forEach((el) => {
          this.contarDespesas(el, carteira);
        });
        transacao["despesas"] = despesaAux;
      } else if (carteira == "Visa") {
        despesaAux = this.despesas.filter(
          (value) =>
            value.nivel == 2 &&
            parseInt(value.id_visa_transacao) ==
              parseInt(transacao.id_visa_transacao)
        );
        despesaAux.forEach((el) => {
          this.contarDespesas(el, carteira);
        });
        transacao["despesas"] = despesaAux;
      } else {
        this.contarDespesas(transacao, carteira);
      }
      this.despesaCarteira[carteira].transacoes.push(transacao);
    },
    contarDespesas(despesaAux, carteira) {
      if (
        despesaAux.st_lancamento === "L" ||
        despesaAux.st_lancamento === "A" ||
        despesaAux.st_lancamento === "E"
      ) {
        this.despesaCarteira[carteira].somaAprovado += parseFloat(
          despesaAux.vl_lancamento
        );
        this.despesaCarteira[carteira].totalAprovado += 1;
      } else if (
        despesaAux.st_lancamento === "R" ||
        despesaAux.st_lancamento === "J"
      ) {
        this.despesaCarteira[carteira].totalRejeitado += 1;
      }
      this.despesaCarteira[carteira].valorLancado += parseFloat(
        despesaAux.vl_original
      );
    },
    detalhes(data) {
      if (data.item.despesas.length > 0) {
        data.item._showDetails = true;
      }
    },
    montaPorcentagem(index) {
      return (
        (parseFloat(this.despesaCarteira[index].somaAprovado) /
          parseFloat(this.rdvInfo.rdv.vl_despesa)) *
        100
      );
    },
    atribuiCor(nomeCarteira) {
      return this.carteirasInfo.find((el) => el.ds_carteira == nomeCarteira)
        .ds_cor_web;
    },
    corDaPorcentagem(valor) {
      if (100 - parseInt(valor) <= 70) {
        return "danger";
      }
      if (100 - parseInt(valor) <= 90) {
        return "warning";
      }
      return "primary";
    },
    verificarPendencias(item) {
      let pendencias = [];
      if (item.ds_tipo_carteira == "M" || item.ds_tipo_carteira == "V") {
        if (item.despesas.length == 0) {
          pendencias.push({
            nome: "Sem Despesa Vinculada",
            cor: "badge-soft-danger",
          });
          this.despesasNaoVinculada = false;
        }
        if (
          item.despesas.reduce((a, b) => a + parseFloat(b.vl_lancamento), 0) !=
          parseFloat(item.vl_original)
        ) {
          pendencias.push({ nome: "Saldo Pedente", cor: "badge-soft-warning" });
        }
        item.despesas.some((el) => {
          if (el.st_lancamento == "R") {
            pendencias.push({
              nome: "Existe Despesas Rejeitada",
              cor: "badge-soft-danger",
            });
            return true;
          }
        });
      } else if (
        item.ds_carteira == "Recurso próprio" ||
        item.ds_carteira == "Adiantamento"
      ) {
        if (item.vl_lancamento && item.vl_original != item.vl_lancamento) {
          pendencias.push({
            nome: "Despesa Valor Alterado",
            cor: "badge-soft-primary",
          });
        }
        if (item.st_lancamento == "R" || item.st_lancamento == "J") {
          pendencias.push({
            nome: "Despesa Rejeitada",
            cor: "badge-soft-danger",
          });
        }
      } else if (item.ds_tipo_carteira == "U") {
        if (item.st_lancamento == "NV") {
          pendencias.push({
            nome: "Despesa Não Vinculada",
            cor: "badge-soft-danger",
          });
        }
      }
      return pendencias;
    },
    verificarPendenciasAux(item) {
      let pendencias = [];
      if (item.st_lancamento == "NV") {
        pendencias.push({
          nome: "Despesa Não Vinculada",
          cor: "badge-soft-danger",
        });
        this.despesasNaoVinculada = false;
      }
      if (!item.sq_upload) {
        pendencias.push({
          nome: "Falta Comprovante",
          cor: "badge-soft-danger",
        });
      }
      if (item.vl_lancamento && item.vl_original != item.vl_lancamento) {
        pendencias.push({
          nome: "Despesa Valor Alterado",
          cor: "badge-soft-primary",
        });
      }
      if (item.st_lancamento == "R" || item.st_lancamento == "J") {
        pendencias.push({
          nome: "Despesa Rejeitada",
          cor: "badge-soft-danger",
        });
      }
      return pendencias;
    },
    tamanhoDiv() {
      const altura = this.$refs.minhaDiv.offsetHeight;
      const vertical = this.$refs.vertical;
      vertical.style.height = altura + "px";
    },
  },
};
</script>

<style scoped>
.page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
}
.sizeA4 {
  width: 28cm;
  height: 100%;
}
.retangulo {
  width: 2.5em;
  height: 1.5em;
  margin-right: 5px;
}
.vertical {
  border-left: 3px solid gray;
  left: 50%;
}
</style>
